module.exports = __webpack_public_path__ + "static/media/img3-3.78afca60.png";